function generateAvatarSVG(firstName, lastName) {
  const svg = `
  <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" fill="#4b4f52"/>
    <text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" font-size="46" fill="#fcfffd" font-family="Arial, sans-serif" font-weight="lighter">
      ${firstName[0]}${lastName[0]}
    </text>
  </svg>
`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export default generateAvatarSVG;
